import { type RouteRecordRaw } from 'vue-router'

const suppliersRoutes: Array<RouteRecordRaw> = [
  {
    path: '/purchasing/suppliers',
    name: 'suppliers.index',
    component: () => import('@/modules/purchasing/suppliers/views/SuppliersIndex.vue'),
    meta: {
      pageTitle: 'Suppliers Index',
      breadcrumbs: ['Suppliers']
    }
  },
  {
    path: '/purchasing/suppliers/:id',
    name: 'suppliers.show',
    component: () => import('@/modules/purchasing/suppliers/views/SuppliersShow.vue'),
    meta: {
      pageTitle: 'Supplier Show',
      breadcrumbs: ['Suppliers']
    }
  },
  {
    path: '/purchasing/suppliers/create',
    name: 'suppliers.create',
    component: () => import('@/modules/purchasing/suppliers/views/SuppliersEdit.vue'),
    meta: {
      pageTitle: 'Supplier Create',
      breadcrumbs: ['Suppliers']
    }
  },
  {
    path: '/purchasing/suppliers/:id/edit',
    name: 'suppliers.edit',
    component: () => import('@/modules/purchasing/suppliers/views/SuppliersEdit.vue'),
    meta: {
      pageTitle: 'Supplier Edit',
      breadcrumbs: ['Suppliers']
    }
  }
]

export default suppliersRoutes
